export const state = {
    isMobile: false
}

export type State = typeof state